import { memo } from "react";

const EmptyCard = ({isGridOrList}) => {
  
  return (
    <div className={`col-12 list_map feature-list ${isGridOrList ? 'pl10 pr15' : 'pl25 pr25'}`}>
      <div className={"feat_property home7 style4 d-flex align-items-center"}>
        <div className="details">
          <div className="ec_content">
            <div className="emptyheadTitle mb10">Sorry, No Properties Found!</div>
            <div className="emptyTitle mb10">We may not have any properties that match your search, but it's always good to confirm by trying the search again. Here are some helpful hints:</div>
              <ul className="list-style-type-bullet">
                <li className="subTitle">Be sure you spell correctly</li>
                <li className="subTitle">If you search by zip code, make sure you've entered all 5 digits</li>
                <li className="subTitle">Try expanding your search to a larger geographic area (try city, county, state or zip code)</li>
                <li className="subTitle">Enter the MLS # or Hubzu Property ID to quickly find the property you want</li>
                <li className="subTitle">If you search by address, be sure you enter the full address (street #, street name, city, state & zip)</li>
              </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default memo(EmptyCard);
